"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInformationTable = PaymentInformationTable;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const date_fns_1 = require("date-fns");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
function PaymentInformationTable({ paymentInfo }) {
    const intl = (0, react_intl_1.useIntl)();
    const columns = [
        {
            key: 'description',
            dataIndex: 'description',
        },
        {
            key: 'value',
            dataIndex: 'value',
        },
    ];
    const data = Object.keys(paymentInfo).map(key => {
        let value = paymentInfo[key];
        if (key === types_1.PaymentInfoKeys.payment_due) {
            value = (0, date_fns_1.format)((0, date_fns_1.parseISO)(paymentInfo[types_1.PaymentInfoKeys.payment_due].toString()), 'd.MM.yyyy');
        }
        if (key === types_1.PaymentInfoKeys.total_sum) {
            value = `${paymentInfo[key]} €`;
        }
        return {
            description: intl.formatMessage({ id: `admin.payments.${key}` }),
            value,
        };
    });
    return (0, jsx_runtime_1.jsx)(elements_1.Table, { bordered: true, showHeader: false, columns: columns, dataSource: data, pagination: false, rowKey: "value" });
}
